import styled from 'styled-components';

import Modal from './Modal';

export const SIMPLE_LIST_MODAL_WIDTH = 840;
export const SIMPLE_LIST_MODAL_BODY_HEIGHT = 500;
export const SIMPLE_LIST_ENTRY_MODAL_WIDTH = 520;

export const SimpleListModal = styled(Modal).attrs({
  className: 'simple-list-modal',
})`
  .ant-modal-header {
    border-bottom: 1px solid var(--line-gray);
    padding: 25px 30px 20px !important;
    margin-bottom: 0;
  }

  .ant-modal-content {
    width: ${SIMPLE_LIST_MODAL_WIDTH}px;
    max-width: 90vw;
  }

  .ant-modal-body {
    padding: 30px;
    height: ${SIMPLE_LIST_MODAL_BODY_HEIGHT}px;
    box-sizing: border-box;
  }
`;

export const SimpleListEntryModal = styled(Modal).attrs({
  className: 'simple-list-entry-modal compact',
})`
  .ant-modal-content {
    width: ${SIMPLE_LIST_ENTRY_MODAL_WIDTH}px;
    max-width: 90vw;
  }

  .ant-modal-body {
    padding: 24px 30px 0;
  }
`;

export const SimpleListModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const SimpleListModalDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 12px;
  padding-bottom: 16px;
  font-size: 14px;
  color: var(--text-secondary);
`;

export const SimpleListModalTitleStrong = styled.span`
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

export const SimpleListModalHeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 16px;
`;
